export default __webpack_public_path__ + "static/media/icon-marsh.c249741e.svg";